import { IAppRoute } from 'interfaces/route';
import { userRoles } from 'interfaces/user';
import { PureComponent } from 'react';

import DocumentRegisterAndExclusionPage from './Document/ManagerDocuments';
import UserListPage from './User/List';
import VentureListPage from './Venture/List';
import DocumentManagement from './DocumentManagement/List';
import EntityListPage from './Entity/List';

export default class SettingsRouter extends PureComponent {
  public static routes: IAppRoute[] = [
    {
      path: '/users',
      sideDrawer: { display: 'Gestão de acesso', order: 1 },
      roles: [userRoles.admin, userRoles.auditor, userRoles.sysAdmin, userRoles.holding, userRoles.venturer, userRoles.operator],
      component: UserListPage
    },
    {
      path: '/ventures',
      exact: true,
      sideDrawer: { display: 'Empreendimento', order: 2 },
      roles: [userRoles.sysAdmin, userRoles.admin],
      component: VentureListPage
    },
    {
      path: '/entities',
      sideDrawer: { display: 'Módulos/Abas/Subabas', order: 3 },
      roles: [userRoles.sysAdmin, userRoles.admin],
      isProfileSelectedDependent: true,
      component: EntityListPage
    },
    {
      path: '/documents',
      sideDrawer: { display: 'Gestão de documentos', order: 4 },
      roles: [userRoles.sysAdmin, userRoles.admin],
      isProfileSelectedDependent: true,
      component: DocumentRegisterAndExclusionPage
    },
    {
      path: '/gestao-de-arquivos',
      sideDrawer: { display: 'Gestão de Arquivos', order: 5 },
      roles: [userRoles.sysAdmin, userRoles.admin],
      component: DocumentManagement
    }
  ];

  render() {
    return (this.props.children);
  }
}
